<template>
	<b-overlay :show="isLoading">
		<b-row class="gap-y-1">
			<b-col cols="12" md="6">
				<h2 class="text-secondary font-weight-bolder">POR GÉNERO</h2>
			</b-col>
			<b-col cols="12" md="6" class="d-flex justify-content-end align-items-center gap-x-2"></b-col>
		</b-row>
		<hr />
		<VueApexCharts type="pie" height="300" :options="chartOpts" :series="chartData" />
	</b-overlay>
</template>

<script>
import VueApexCharts from "vue-apexcharts"

export default {
	components: { VueApexCharts },
	props: {
		year: Object,
		info: Array,
		count: Number,
	},
	data: () => ({
		isLoading: true,
		chartData: [44, 55],
		chartOpts: {
			labels: ["MACHO", "HEMBRA"],
			colors: ["#001219", "#005F73"],
		},
	}),
	methods: {
		async getData() {
			if (this.info) {
				this.isLoading = false
			}
			this.chartData = this.info.map((d) => d.counter)
			this.chartOpts = {
				labels: this.info.map((d) => d.gender),
				colors: ["#001219", "#005F73"],
			}
		},
	},
	watch: {
		info() {
			this.getData()
		},
		count() {
			this.isLoading = true
		},
	},
}
</script>
